import styled from 'styled-components';
import { Box, Heading, Paragraph, Stack } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import { GridLayout, Scroll } from '@99designs/marketing-ui';
import { List } from './List';
import { ProductCard } from './ProductCard';
import type { ComparativeProduct } from '../../types';

export interface ProductComparisonProps {
    products: ComparativeProduct[];
}

const Grid = styled(Box)`
    grid-template-columns: repeat(4, 1fr);
    gap: ${spaces['1bu']};

    > * {
        width: 300px;
    }
`;

export function ProductComparison({ products }: ProductComparisonProps) {
    const isContestProduct = products
        .map((product) => {
            return product.collaborationMethod === 'COLLABORATION_METHOD_CONTEST';
        })
        .every((value, _, products) => value === products[0]);

    return (
        <Stack space="1bu">
            <GridLayout>
                <Stack space="0.5bu">
                    <Heading appearanceLevel={4} accessibilityLevel={2}>
                        {__('Simple pricing for every budget')}
                    </Heading>
                    <Paragraph>{__('Choose a package that suits your needs')}</Paragraph>
                </Stack>
            </GridLayout>
            <Scroll controlsEnabled gridWidth={1300}>
                <Grid
                    display="grid"
                    paddingLeft={['none', '0.75bu', '1bu', '1bu']}
                    paddingRight={['none', '0.75bu', '1bu', '1bu']}
                >
                    {products.map((product) => {
                        return (
                            <ProductCard
                                key={product.key}
                                product={product}
                                isContestProduct={isContestProduct}
                            />
                        );
                    })}
                </Grid>
                <Grid
                    display="grid"
                    paddingLeft={['none', '0.75bu', '1bu', '1bu']}
                    paddingRight={['none', '0.75bu', '1bu', '1bu']}
                >
                    {products.map((product) => {
                        return <List key={product.key} features={product.features} />;
                    })}
                </Grid>
            </Scroll>
        </Stack>
    );
}
